import React, { useCallback } from "react";

// COMPONENTS
import PDPImage from "../../shared/components/pdp-image";
import useSwatchHoverEvent from "../../shared/hooks/useSwatchHoverEvent";

// STYLES
import styles from "../styles/carousel.module.scss";

const HoverImage = ({
  displayName,
  isMobile,
  allColours,
  swatchData,
  pdpCarouselWWMTImageWidths
}) => {
  const hoveredColorCode = useSwatchHoverEvent(
    (params) => params.detail?.swatch?.color?.code
  );

  const getHoveredImageInfo = useCallback(() => {
    const foundImages = allColours?.find?.(
      ({ color } = {}) => hoveredColorCode === color?.code
    );
    return (
      foundImages && {
        imageUrl: foundImages.imageInfo?.[0],
        alt: `${hoveredColorCode} ${displayName.replace("*", "")}` // Wrong displayName
      }
    );
  }, [hoveredColorCode, displayName, allColours]);

  const hoveredImageInfo = hoveredColorCode && getHoveredImageInfo();
  const isSelected = hoveredColorCode === swatchData?.color?.code;
  const showHoverImage = !isSelected && !isMobile && hoveredImageInfo;

  return (
    showHoverImage && (
      <PDPImage
        lazy={false}
        alt={hoveredImageInfo?.alt}
        src={hoveredImageInfo?.imageUrl}
        className={`${styles.image} ${styles.hoveredSwatchImage}`}
        sizes={pdpCarouselWWMTImageWidths}
      />
    )
  );
};

export default HoverImage;
